export const API_HOST = "https://api.linguascores.com"
export const WS_API_HOST = "wss://api.linguascores.com"
export const HOSTNAME = "linguascores.com"
export const APP_URL = "https://app.linguascores.com"